import React from 'react';
import Legal from '../Legal';

const Refund = () => {
    return (
        <Legal title="Refund & Cancellation Policy" lastUpdated="January 1, 2026">
            <h3>1. The "Confidence Guarantee"</h3>
            <p>
                At ARIVUNEST, we are committed to your success. We understand that life happens, and sometimes a course might not be the right fit.
                Our refund policy is designed to be fair and transparent.
            </p>

            <h3>2. 5-Day Money-Back Guarantee</h3>
            <p>
                We offer a 5-day money-back guarantee for all our self-paced courses (Premium Student Tier).
                If you are not satisfied with the content or methodology, you may request a full refund within 5 days of your purchase.
            </p>
            <p>
                <strong>Conditions for Refund:</strong>
            </p>
            <ul>
                <li>The request must be made via email to refunds@arivunest.com within 120 hours (5 days) of the initial transaction.</li>
                <li>You have not completed more than 20% of the course content.</li>
                <li>You have not downloaded more than 5 protected resources (PDFs, Audio files).</li>
            </ul>

            <h3>3. Instructor-Led Batches</h3>
            <p>
                For Instructor-Assisted programs or Live Batches (Instructor+ Tier):
            </p>
            <ul>
                <li><strong>Cancellations 7 Days Prior:</strong> Full refund minus a small processing fee (5%).</li>
                <li><strong>Cancellations &lt; 48 Hours Prior:</strong> No refund, but you may transfer your enrollment to a future batch.</li>
                <li><strong>After Batch Start:</strong> No refunds are issued once the live batch has commenced, as the seat has been reserved specifically for you.</li>
            </ul>

            <h3>4. Technical Issues</h3>
            <p>
                If you are unable to access the course due to a technical error on our end that we cannot resolve within 48 hours,
                you are entitled to a full refund regardless of the time elapsed, provided you have contacted support immediately upon discovering the issue.
            </p>

            <h3>5. Processing Timeline</h3>
            <p>
                Refunds are processed to the original method of payment.
                Please allow 5-10 business days for the credit to appear on your bank statement, depending on your card issuer's policies.
            </p>
        </Legal>
    );
};

export default Refund;
